/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Marketing Budget — RTK Query slice.

   Same transport pattern as growthosBrandsApiSlice.js: shared axios helpers,
   raw JSON responses, no envelope unwrap needed beyond res.data.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get, putGeneric } from '../common/constants'

const BUDGET = apiConstants.GROWTHOS_ADMIN_BUDGET // 'growthos-admin/budget'

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosBudgetApiSlice = createApi({
  reducerPath: 'growthosBudgetApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['Budget'],
  endpoints: (b) => ({
    getBudget: b.query({
      queryFn: () => run(get(BUDGET)),
      providesTags: ['Budget'],
    }),
    // amount: null clears that month's entry — matches PUT /settings/budget exactly.
    setSpend: b.mutation({
      queryFn: ({ month, subcategoryId, amount, note }) => run(putGeneric(BUDGET, { month, subcategoryId, amount, note })),
      invalidatesTags: ['Budget'],
    }),
  }),
})

export const { useGetBudgetQuery, useSetSpendMutation } = growthosBudgetApiSlice
